import React from 'react';
import { Button } from '@progress/kendo-react-buttons'
import ParcelVirsion from '../Parcel-Right-panel/ParcelVirsion';
import $ from 'jquery';

class WizardDetailModalForm extends React.Component {
   constructor(props) {
      super(props);
      this.state = {
         data: {},


      }
   }

   /* Esta é a primeira etapa após o construxctor para carregar este componente  */

   componentDidMount() {
      this.setState({
         data: this.props.listData
      })
   }

   componentDidUpdate(prevProps) {
      console.log(this.props);
      if (prevProps.tab !== this.props.tab || prevProps.listData !== this.props.listData) {
         this.setState({
            data: this.props.listData
         })
      }
   }
   closePopup = () => {
      try {
          if (this.props.closePopup) {
              this.props.closePopup();
          } else {
              $(".left-popup").trigger('click');
          }
      } catch (error) {
          this.setState({error})
      }
  }

   /*  para renderizar o conteúdo html da página   */

   render() {
      if (this.props.tab === 'detail') {
         return (
            <div className="modal-content">
               <div className="modal-header info-wirad d-flex justify-content-between flex-wrap">
                  <h4 className="modal-title pl-0">Dados de entidade</h4>
                  <div>
                     {/* {
                        !this.props.onlyDetails &&
                        <span className="secondty-btn cursor-pointer text-capitalize mr-2">Ficha da entidade</span>
                     } */}
                     <Button onClick={() => this.props.closePopup()} className="mr-2 btn-ivdp-primary k-primary" >Fechar</Button>
                  </div>
               </div>
               <div className="modal-body">
                  <div className="details">
                     {/* <div className="row">
                        <div className="col-md-12">
                           {
                              !this.props.onlyDetails &&
                              <ul className="list-unstyled list-inline info-small">
                                 <li className="list-inline-item">Entidade com login</li>
                                 <li className="list-inline-item">Aprovado</li>
                              </ul>
                           }
                          
                        </div>
                     </div> */}
                     <div className="row mt-3">
                        {
                           this.props.listData &&
                           <div className="col-md-6">
                              <p>Número</p>
                              <h3>{this.props.listData.nifap}</h3>
                           </div>
                        }
                        {
                           this.props.listData &&
                           <div className="col-md-6">
                              <p>NIF</p>
                              <h3>{this.props.listData.nif}</h3>
                           </div>
                        }
                        {
                           this.props.listData &&
                           <div className="col-md-6">
                              <p>Nome</p>
                              <h3>{this.props.listData.nome}</h3>
                           </div>
                        }
                        {
                           this.props.billobj ?
                              <div className="col-md-12">
                                 <p><strong>Morada: </strong>{this.props.billobj.address_line1 || ""} </p>
                                 <p><strong>Localidade: </strong>{this.props.billobj.address_line2 || ""}</p>
                                 <p><strong>Código Postal: </strong> {this.props.billobj.pin || ""}</p>
                                 <p><strong>Distrito: </strong> {this.props.billobj.desdis || ""}, <strong>Concelho: </strong> {this.props.billobj.descon || ""}, <strong>Freguesia: </strong> {this.props.billobj.desfrg || ""} </p>
                              </div>
                              :
                              <>
                                 {
                                    this.props.listData &&
                                    <>
                                       <div className="col-md-12">
                                          <p>Morada</p>
                                          <h3>{this.props.listData.morada}</h3>

                                          <p>Localidade</p>
                                          <h3>{this.props.listData.localidade}</h3>

                                          <p>Código Postal</p>
                                          <h3>{this.props.listData.postalcode}</h3>

                                         
                                       </div>
                                       {
                                          this.props.entityContact &&
                                          this.props.entityContact.length > 0 &&
                                          this.props.entityContact.map(_r => (
                                             _r.codTipoContacto2 === 'TLM' ?
                                             <div className="col-md-6">
                                                <p>Telemóvel</p>
                                                <h3>{_r.contacto}</h3>
                                             </div>
                                             :
                                             _r.codTipoContacto2 === 'TEL' ?
                                             <div className="col-md-6">
                                                <p>Telefone</p>
                                                <h3>{_r.contacto}</h3>
                                             </div>
                                             :
                                             _r.codTipoContacto2 === 'EMAIL' &&
                                             <div className="col-md-12">
                                                <p>Email institucional</p>
                                                <h3>{_r.contacto}</h3>
                                             </div>
                                          ))
                                       }
                                    </>
                                 }
                              </>
                        }

                     </div>
                  </div>
               </div>
            </div>
         )
      } else if (this.props.tab === 'versions') {
         return (
            <div className="modal-content">
               <div className="modal-header info-wirad d-flex justify-content-between flex-wrap">
                  <h4 className="modal-title pl-0">Versions</h4>
                  <div>
                     <Button onClick={() => this.closePopup()} className="mr-2 btn-ivdp-secondary" >Cancelar</Button>
                  </div>
               </div>
               <div className="modal-body">
                  <ParcelVirsion id={this.props.id} date={new Date()} />
               </div>
            </div>
         )
      }
   }
}

export default WizardDetailModalForm;